
// window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

// Add QR Code Plugin
window.QRCode = require('qrcode');

// Add jQuery Mask Plugin
require('jquery-mask-plugin');

window.currency = require('currency.js');

import Panzoom from '@panzoom/panzoom'

window.Panzoom = Panzoom;

import './validation';
import './masonry';
import './popover';
import './scrollbar';
import './search';
import './sidebar';
import './skycons';
import './datatable';
import './datepicker';
import './datetimepicker';
import './email';
import './utils';
import './sweetalert2';
import './select2';
import './axios'

import './utils/objUtils';
import './utils/stringUtils';
import './utils/moneyUtils';
